import { Component } from '@angular/core';
import { BaseForm } from '@app/modules/forms/base.form';

@Component({
    selector: 'app-document-acknowledge-form',
    templateUrl: './acknowledge.template.html',
})
export class AcknowledgeForm extends BaseForm {
    // because form controls still count false as a filled in value and we need them to select true here
    acknowledged: undefined | true = undefined;

    onCheckboxToggle(): void {
        this.acknowledged = this.acknowledged ? undefined : true;
    }
}
